
export default defineNuxtPlugin(() => {
    const colorIsBright = (color) => {
        if (!color) {
            return false
        }

        const c = color.substring(1) // strip #
        const rgb = parseInt(c, 16) // convert rrggbb to decimal
        const r = (rgb >> 16) & 0xFF // extract red
        const g = (rgb >> 8) & 0xFF // extract green
        const b = (rgb >> 0) & 0xFF // extract blue

        const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b

        return luma >= 128
    }

    return {
        provide: {
            colorIsBright
        }
    }
})
